import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import * as i1 from '@spartacus/core';
import { LogoutEvent, GlobalMessageType, provideDefaultConfigFactory, facadeFactory, CxEvent } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { LAUNCH_CALLER } from '@spartacus/storefront';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * User account event listener.
 */
let UserAccountEventListener = /*#__PURE__*/(() => {
  class UserAccountEventListener {
    constructor(eventService, globalMessageService) {
      this.eventService = eventService;
      this.globalMessageService = globalMessageService;
      this.subscriptions = new Subscription();
      this.onAuth();
    }
    /**
     * Registers events for the auth events.
     */
    onAuth() {
      this.subscriptions.add(this.eventService.get(LogoutEvent).subscribe(() => {
        this.globalMessageService.add({
          key: 'authMessages.signedOutSuccessfully'
        }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
      }));
    }
    ngOnDestroy() {
      this.subscriptions.unsubscribe();
    }
    static {
      this.ɵfac = function UserAccountEventListener_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UserAccountEventListener)(i0.ɵɵinject(i1.EventService), i0.ɵɵinject(i1.GlobalMessageService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UserAccountEventListener,
        factory: UserAccountEventListener.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return UserAccountEventListener;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let UserAccountEventModule = /*#__PURE__*/(() => {
  class UserAccountEventModule {
    constructor(_userAccountEventListener) {
      // Intentional empty constructor
    }
    static {
      this.ɵfac = function UserAccountEventModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UserAccountEventModule)(i0.ɵɵinject(UserAccountEventListener));
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: UserAccountEventModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return UserAccountEventModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const USER_ACCOUNT_FEATURE = 'userAccount';
const USER_ACCOUNT_CORE_FEATURE = 'userAccountCore';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
// TODO: Inline this factory when we start releasing Ivy compiled libraries
function defaultUserAccountComponentsConfig() {
  const config = {
    featureModules: {
      [USER_ACCOUNT_FEATURE]: {
        cmsComponents: ['LoginComponent', 'ReturningCustomerLoginComponent', 'VerifyOTPTokenComponent', 'ReturningCustomerRegisterComponent', 'MyAccountViewUserComponent', 'ReturningCustomerOTPLoginComponent', 'RegisterCustomerWithOTPComponent']
      },
      // by default core is bundled together with components
      [USER_ACCOUNT_CORE_FEATURE]: USER_ACCOUNT_FEATURE
    }
  };
  return config;
}
let UserAccountRootModule = /*#__PURE__*/(() => {
  class UserAccountRootModule {
    static {
      this.ɵfac = function UserAccountRootModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UserAccountRootModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: UserAccountRootModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfigFactory(defaultUserAccountComponentsConfig)],
        imports: [UserAccountEventModule]
      });
    }
  }
  return UserAccountRootModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let UserAccountFacade = /*#__PURE__*/(() => {
  class UserAccountFacade {
    static {
      this.ɵfac = function UserAccountFacade_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UserAccountFacade)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UserAccountFacade,
        factory: () => (() => facadeFactory({
          facade: UserAccountFacade,
          feature: USER_ACCOUNT_CORE_FEATURE,
          methods: ['get', 'getById']
        }))(),
        providedIn: 'root'
      });
    }
  }
  return UserAccountFacade;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let VerificationTokenFacade = /*#__PURE__*/(() => {
  class VerificationTokenFacade {
    static {
      this.ɵfac = function VerificationTokenFacade_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VerificationTokenFacade)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VerificationTokenFacade,
        factory: () => (() => facadeFactory({
          facade: VerificationTokenFacade,
          feature: USER_ACCOUNT_CORE_FEATURE,
          methods: ['createVerificationToken']
        }))(),
        providedIn: 'root'
      });
    }
  }
  return VerificationTokenFacade;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
LAUNCH_CALLER['ACCOUNT_VERIFICATION_TOKEN'] = 'ACCOUNT_VERIFICATION_TOKEN';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var VERIFICATION_TOKEN_DIALOG_ACTION = /*#__PURE__*/function (VERIFICATION_TOKEN_DIALOG_ACTION) {
  VERIFICATION_TOKEN_DIALOG_ACTION["OK"] = "OK";
  return VERIFICATION_TOKEN_DIALOG_ACTION;
}(VERIFICATION_TOKEN_DIALOG_ACTION || {});
/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class UserAccountEvent extends CxEvent {}
let UserAccountChangedEvent = /*#__PURE__*/(() => {
  class UserAccountChangedEvent extends UserAccountEvent {
    static {
      this.type = 'UserAccountChangedEvent';
    }
  }
  return UserAccountChangedEvent;
})();
/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/** AUGMENTABLE_TYPES_END */
/**
 * Generated bundle index. Do not edit.
 */
export { USER_ACCOUNT_CORE_FEATURE, USER_ACCOUNT_FEATURE, UserAccountChangedEvent, UserAccountEvent, UserAccountEventListener, UserAccountEventModule, UserAccountFacade, UserAccountRootModule, VERIFICATION_TOKEN_DIALOG_ACTION, VerificationTokenFacade, defaultUserAccountComponentsConfig };
